'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _startCase2 = require('lodash/startCase');

var _startCase3 = _interopRequireDefault(_startCase2);

var _keys2 = require('lodash/keys');

var _keys3 = _interopRequireDefault(_keys2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _forEach2 = require('lodash/forEach');

var _forEach3 = _interopRequireDefault(_forEach2);

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

exports.getMacroKey = getMacroKey;
exports.applyMacros = applyMacros;

var _num = require('@nerdwallet/nw-client-lib/num');

var _num2 = _interopRequireDefault(_num);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var replaceValue = function replaceValue(keysIndex, formattedValue, value) {
  if ((0, _isString3.default)(value)) {
    return value && value.replace('{{' + keysIndex + '}}', formattedValue);
  }

  if ((0, _isArray3.default)(value)) {
    return value.map(function (item) {
      return replaceValue(keysIndex, formattedValue, item);
    });
  }

  return value;
}; // Dependencies
function getMacroKey(config, propName) {
  if (config[propName]) {
    var propValue = config[propName];
    // First replace all of the string minus the macro.
    var macroStr = propValue.replace(/[^{{\d}}]/g, '');

    if (macroStr !== '') {
      // Replace the {{ and the }} and find the key index.
      var keyIndex = macroStr.replace('{{', '').replace('}}', '');
      var keyConfig = config.keys[keyIndex];

      // Do we have a corresponding key config ?
      if (keyConfig) {
        // Return the key string.
        return keyConfig.key;
      }
    }
  }

  // If we didn't find a macro, return the unaltered key.
  return config.key;
}

function applyMacros(rawConfig, data) {
  var isObject = !(0, _isArray3.default)(rawConfig);
  var rawConfigAsArray = rawConfig;

  // Is the config an object ?
  if (isObject) {
    // Convert it to an array
    rawConfigAsArray = [rawConfig];
  }

  var result = rawConfigAsArray.map(function (configParam) {
    // Deep clone the config.
    var config = (0, _cloneDeep3.default)(configParam);

    (0, _forEach3.default)(config.keys || [], function (valueCfg, keysIndex) {
      var formattedValue = null;

      // Do we have a getValue in the config ?
      if (typeof valueCfg.getValue === 'function') {
        // Invoke the function ...
        formattedValue = valueCfg.getValue(data);
      } else {
        formattedValue = (0, _get3.default)(data, valueCfg.key, '');
      }

      if (formattedValue !== '' && valueCfg.type !== undefined) {
        var formatFn = (0, _startCase3.default)(valueCfg.type);
        formattedValue = _num2.default['format' + formatFn](formattedValue, valueCfg.formatterStr);
      }

      (0, _keys3.default)(config).forEach(function (key) {
        config[key] = replaceValue(keysIndex, formattedValue, config[key]);
      });
    });

    return config;
  });

  // If an object was passed in, return the object or else return the resulting array.
  return isObject ? result[0] : result;
}